export const decideResolution = (client, req) => client.rpc('service-kyc', '1/2020-04-01/decide_resolution', req);
export const getLatestKyc = (client, req) => client.rpc('service-kyc', '1/2020-04-01/get_latest_kyc', req);
export const getLatestKycOps = (client, req) => client.rpc('service-kyc', '1/2023-01-20/get_latest_kyc_ops', req);
